import { render, staticRenderFns } from "./addreserve.vue?vue&type=template&id=0a8f571c&scoped=true&"
import script from "./addreserve.vue?vue&type=script&lang=js&"
export * from "./addreserve.vue?vue&type=script&lang=js&"
import style0 from "./addreserve.vue?vue&type=style&index=0&id=0a8f571c&lang=scss&scoped=true&"
import style1 from "./addreserve.vue?vue&type=style&index=1&id=0a8f571c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f571c",
  null
  
)

export default component.exports